import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'title',
    null,
    'Trace Icons_1-3'
  ),
  React.createElement('path', { d: 'M31.76,17.18A.66.66,0,0,0,31.3,17H28l-2.5-6.17a.64.64,0,0,0-.6-.41h-5V6.69A.65.65,0,0,0,19.26,6H3.93a.65.65,0,0,0-.65.65v6.85h1.3V7.34h14V22.47H13.25a2.83,2.83,0,0,0-5.51,0H4.58v-1H3.28v1.65a.65.65,0,0,0,.65.65H7.74a2.83,2.83,0,0,0,5.51,0H22a2.83,2.83,0,0,0,5.52,0H31.3a.65.65,0,0,0,.65-.65V17.64A.66.66,0,0,0,31.76,17.18ZM10.5,24.66A1.54,1.54,0,1,1,12,23.12,1.54,1.54,0,0,1,10.5,24.66Zm14.23,0a1.54,1.54,0,1,1,1.54-1.54A1.54,1.54,0,0,1,24.73,24.66Zm5.92-2.19H27.49a2.83,2.83,0,0,0-5.52,0H19.91V11.72h4.53l2.5,6.17a.65.65,0,0,0,.6.41h3.11Z' }),
  React.createElement('rect', { x: '0.05', y: '18.19', width: '6.68', height: '1.3' }),
  React.createElement('rect', { x: '1.05', y: '15.21', width: '5.68', height: '1.3' })
));